import React from "react";
import { Heart, MessagesSquare, Sprout, Ear } from "lucide-react";
import { PHARMACY_PHOTOS, photoSrcSet } from "@/lib/site-data";

const VALUES = [
    {
        icon: Heart,
        title: "Proximité",
        text:
            "Nous connaissons nos clients, et nos clients nous connaissent. Cette confiance bâtie jour après jour est au cœur de notre approche.",
    },
    {
        icon: MessagesSquare,
        title: "Conseil personnalisé",
        text:
            "Prendre le temps d'écouter pour trouver la solution adaptée — pas un produit, une réponse à votre situation.",
    },
    {
        icon: Sprout,
        title: "Diversité des prestations",
        text:
            "Vaccinations, dépistages, médecines complémentaires, dermocosmétique — un éventail pensé pour vous accompagner à chaque étape.",
    },
    {
        icon: Ear,
        title: "Écoute & discrétion",
        text:
            "Un cadre chaleureux et confidentiel pour parler librement de ce qui vous préoccupe.",
    },
];

export const About = () => {
    return (
        <section
            id="a-propos"
            className="relative py-24 lg:py-32 bg-white"
            data-testid="about-section"
        >
            <div className="max-w-[1180px] mx-auto px-6 lg:px-10">
                {/* Photo split — pharmacy façade */}
                <div className="grid lg:grid-cols-12 gap-8 lg:gap-12 items-center">
                    <figure className="lg:col-span-7 overflow-hidden border border-brand-line" data-testid="about-photo-street">
                        <img
                            src={PHARMACY_PHOTOS.street}
                            srcSet={photoSrcSet(PHARMACY_PHOTOS.street)}
                            sizes="(min-width: 1024px) 640px, 100vw"
                            alt="La façade de la Pharmacie La Lutrive dans la Grand-Rue à Lutry"
                            className="w-full h-full object-cover aspect-[4/3]"
                            loading="lazy"
                        />
                    </figure>
                    <div className="lg:col-span-5">
                        <p className="ll-eyebrow text-brand-primary mb-3">Au cœur de Lutry</p>
                        <h3 className="font-display text-2xl lg:text-3xl text-brand-ink leading-tight">
                            Grand-Rue 53, <span className="italic text-brand-primary">à deux pas du lac</span>.
                        </h3>
                    </div>
                </div>

                {/* Values grid */}
                <div className="mt-16 grid md:grid-cols-2 lg:grid-cols-4 gap-5 lg:gap-6">
                    {VALUES.map((v) => (
                        <article
                            key={v.title}
                            className="group border border-brand-line p-6 lg:p-7 bg-white hover:border-brand-primary/40 hover:-translate-y-0.5 transition-all duration-300"
                            data-testid={`about-value-${v.title.toLowerCase().replace(/\s+/g, "-")}`}
                        >
                            <div className="h-11 w-11 rounded-full bg-brand-mint/40 text-brand-primary inline-flex items-center justify-center mb-5 group-hover:bg-brand-primary group-hover:text-white transition-colors">
                                <v.icon className="h-5 w-5" />
                            </div>
                            <h3 className="font-display text-xl text-brand-ink mb-2 leading-tight">{v.title}</h3>
                            <p className="font-sans text-sm leading-relaxed text-brand-ink/70">{v.text}</p>
                        </article>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default About;
